import "./libs/jquery.easing.1.3";
import "./libs/modernizr-custom";
import "./libs/userAgentChecker";
import "./libs/jquery.matchHeight";
import "./libs/slick";
import "./libs/lazysizes";
import "./libs/ls.unveilhooks";
import "./libs/svgxuse.min";

import { slider } from "./slider";
import { header, headerResize } from "./header";
import { link } from "./link";
// import { video } from "./video";
import { modal } from "./modal";
import { form } from "./form";
import { click_area } from "./click-area";
import { retina } from "./retina";
import { height_align } from "./height_align";
import { current } from "./current";

jQuery(window).on("load", function () {
	height_align();
	// slider();
	link();
	form();
	header();
	retina();
	// video();
	modal();
	click_area();
	current();
});

$(document).ready(function() {
	slider();
});

// $(window).resize(function() {});

var timer = false;
var winWidth = $(window).width();
var winWidth_resized;

$(window).resize(function () {
	if (timer !== false) {
		clearTimeout(timer);
	}
	timer = setTimeout(function () {
		winWidth_resized = $(window).width();

		if (winWidth != winWidth_resized) {
			height_align();
			retina();
			headerResize();
			// video();

			winWidth = $(window).width();
		}
	}, 200);
});
